import { api_POST } from "./_api.js";

const exportacaoDiarioOficial_api = {
    getExportacaoDiarioOficial: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("ExportacaoDiarioOficial/GetExportacaoDiarioOficial", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    ExportacaoDiarioOficial: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("ExportacaoDiarioOficial/ExportacaoDiarioOficial", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default exportacaoDiarioOficial_api;
